import DxmlList from "../DxmlList"
import DxmlParagraph from "../DxmlParagraph"
import RichTextEditor from "../../RichTextEditor"
import { useEditorFile } from "../../../../../hooks/useEditorFile";
import { useEffect, useState } from "react";

export default function DxmlText({ editorText }) {
    const { getKeyById, isEditorTextEmpty } = useEditorFile();
    const [cssStyle, setCssStyle] = useState({});

    const handleStyle = () => {
        const cssStyle = {};
        if (typeof editorText.ReactCssStyle === 'object') {
            Object.assign(cssStyle, editorText.ReactCssStyle);
        }
        if (editorText.IsTextBox && typeof editorText.TextboxCssStyle === 'object') {
            Object.assign(cssStyle, editorText.TextboxCssStyle);
        }
        setCssStyle(cssStyle);
    }

    useEffect(() => {
        handleStyle();
    }, []);

    if (editorText.WriteEnabled) {
        return (
            <div className={`${editorText.ParentTableId ? "tw-my-1.5" : ""}`}>
                <RichTextEditor editorText={editorText}></RichTextEditor>
            </div>
        )
    }

    if (editorText.HasList) {
        return (
            <div className={`${editorText.ParentTableId ? "tw-my-1.5" : ""}`}>
                <div className={editorText.ParentTableId ? "tw-px-2 tw-py-1" : "tw-border tw-rounded-sm tw-shadow-sm tw-px-3 tw-py-3 tw-bg-brand-background"} style={cssStyle}>
                    <DxmlList editorList={editorText.Items[0]}></DxmlList>
                </div>
            </div>
        )
    }

    if (isEditorTextEmpty(editorText)) {
        return <></>
    }

    return (
        <div className={`${editorText.ParentTableId ? "tw-my-1.5" : ""}`}>
            <div className={editorText.ParentTableId ? "tw-px-2 tw-py-1" : "tw-border tw-rounded-sm tw-shadow-sm tw-px-3 tw-py-3 tw-bg-brand-background"} style={cssStyle}>
                {editorText.Items.map((editorParagraph) => (
                    <DxmlParagraph key={getKeyById(editorParagraph)} editorParagraph={editorParagraph}></DxmlParagraph>
                ))}
            </div>
        </div>

    )
}